import axiosClient from './axiosClient';

const rideGeocodingApi = {
  reverse: (lat, lon) => axiosClient.get('/rides/geocoding/reverse', { params: { lat, lon } }),
};

export default rideGeocodingApi;
